
import { todayDate } from "@/config/constant";
import { ICarrierAssignment, IPickupLocation,IDeliveryLocation, ILoad, IloadDetails, EquipmentType, LoadSize, LoadStatus, LocationClass } from "@/types";

export interface LoadValidationData {
  load: IloadDetails;
  customer: {
    customerId: string | null;
    customerContactPerson: string | null;
  };
  asset?: ICarrierAssignment;
  pickup: IPickupLocation[];
  delivery: IDeliveryLocation[];
  document: {
    files: File[];
  };
}
export const initalLoadData: ILoad = {
  search:"",
  pnonumber: undefined,
   signature:"",
  AcceptTerms:false,
  termsandconditions:"",
  deletedfiles: [],
  loadDetails: {
    loadNumber: '',
    loadAmount: null,
    status:LoadStatus.PENDING,
    commodity: 'Produce',
    loadSize:LoadSize.FULL,
    declaredValue:undefined,
    weight:undefined,
    temperature:undefined,
    equipmentType: EquipmentType.REEFER,
    equipmentLength: '53',
    notes: '',
    temperatureUnit: "F"
  },
  customerContactPerson: null,
  customerId: null,
  carrierIds: {
    carrier: "",
    powerunit: "",
    trailer: "",
    carrierPay: 0,
    assignDrivers: [],
    pnonumber: undefined,
    carrierPayBifurcations:[],
    contactPerson: null
  },
  deliveryLocationId: [
    {
      requirements: [],
      address: "",
      state: "",
      city: "",
      zipcode: "",
      locationClass: LocationClass.WAREHOUSE,
      date:todayDate,
      time: "",
      endTime: "",
      notes: "",
      deliveryNumber: "",
      weight: undefined,
      casecount: 0,
      palletcount:0
    },
  ],
  pickupLocationId: [
    {
      address: "",
      state: "",
      city: "",
      zipcode: "",
      locationClass: LocationClass.WAREHOUSE,
      date:todayDate,
      time: "",
      endTime: "",
      requirements: [],
      notes: "",
      pickupNumber: "",
      checkin: undefined,
      checkout: undefined,
      weight:undefined,
      casecount: 0,
      palletcount:0
    },
  ],
  files: [],
  id: null,
  activeTab: "load",
  CarrierLoading:false,
  CustomerLoading:false
};
export const defaultCarrierAssignment: ICarrierAssignment = {
  carrier: '',
  assignDrivers: [],
  carrierPay: 0,
  carrierPayBifurcations: [],
  powerunit: '',
  trailer: '',
  contactPerson: null,
};
export const initialLoadetails = initalLoadData.loadDetails;
export const initialCustomerInformation = initalLoadData.customerId;
export const initialcarrierIds = initalLoadData.carrierIds;
export const initialDeliveryLocations = initalLoadData.deliveryLocationId[0];
export const initialPickupLocations = initalLoadData.pickupLocationId[0];

export const initialDocumentUpload = {
  files: [],
  freightCharge: 'Prepaid'
};